<script>
import chiefComplaintMixin from '@/Mixins/BaseInformation/ChiefComplaintMixin';
import chiefComplaintHelper from '@/Helpers/BaseInformation/ChiefComplaintHelper';
import TrainingMixin from '@/Mixins/training.mixin';
import AttachmentHelper from '@/Helpers/BaseInformation/ChiefComplaint/attachment.helper';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import AttachmentMixin from '@/Mixins/BaseInformation/ChiefComplaint/attachment.mixin';
import confirmDialog from '@/components/ConfirmDialog.vue';
import AppBox from '@/components/app/box.vue';
import AppTitleHeader from '@/components/app/TitleHeader.vue';
import AlertComponent from '@/components/AlertComponent.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
export default {
  name: 'ChiefComplaintManagment',
  title: 'تشخیص احتمالی پرستار',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
    PaginationComponent,
    AppPageContainer,
    AppBox,
    AppTitleHeader,
  },
  mixins: [
    pagination,
    ShearedMixin,
    chiefComplaintMixin,
    chiefComplaintHelper,
    snackBar,
    ShearedHelper,
    TrainingMixin,
    AttachmentMixin,
    AttachmentHelper,
  ],
  created() {
    this.$root.$refs.ChiefComplaintManagment = this;

  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      // this.$refs.pagination.newPageSize = 10;
      // this.$refs.pagination.pageSize = 10;
      this.getListOfChiefComplaintsWithPagination();
    },
    previous: function () {
      this.getListOfChiefComplaintsWithPagination();
      this.$refs.pagination.page = this.page;
    },
    next: function () {
      this.getListOfChiefComplaintsWithPagination();
      this.$refs.pagination.page = this.page;
    },
    input: function () {
      this.getListOfChiefComplaintsWithPagination();
      this.$refs.pagination.page = this.page;
    },
  },
  computed: {
    chiefComplaintFilteredList() {
      return this.chiefComplaintPaginationList.filter((u) => {
        return u.title.toLowerCase().includes(this.searchTitle.toLowerCase());
      });
    },
  },
};
</script>
<template>
  <app-page-container title="مدیریت تشخیص احتمالی پرستار">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="1" class="mr-n6">
        <v-btn class="mx-2 mt-3" fab dark small @click="showSearchModal()" color="darkColor" elevation="0">
          <v-icon dark>mdi-filter mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1" class="mr-n6 mt-6" v-if="isSearch">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon light v-bind="attrs" v-on="on" @click="removeFilters()">
              mdi-filter-remove mdi-18px
            </v-icon>
          </template>
          <span>حذف فیلتر ها</span>
        </v-tooltip>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="3" class="text-left" v-if="accessDenyAddEditChief">
        <v-btn rounded color="darkColor" dark @click="enableAddEditFunction(1, 0)"
          class="mt-3 normal-letter-spacing ml-3">
          <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
          افزودن تشخیص پرستار
        </v-btn>
      </v-col>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main">
        <v-col cols="12" class="pa-0">
          <v-card elevation="0" class="card-width body-card pa-0">
            <v-card-text class="pa-0">
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <template>
                    <v-data-table fixed-header :headers="chiefComplaintManagmentInformationTableHeaders"
                      :items="chiefComplaintFilteredList" :page.sync="page"
                      :items-per-page="chiefComplaintFilteredList.length" height="68vh" :hide-default-footer="true"
                      multi-sort class="elevation-0">
                      <template v-slot:[`item.status`]="{ item }">
                        <v-tooltip top v-if="item.status === false">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="#F56060" v-bind="attrs" v-on="on">
                              mdi-eye-off mdi-24px
                            </v-icon>
                          </template>
                          <span>غیر فعال</span>
                        </v-tooltip>
                        <v-tooltip top v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="#3BCA79" v-bind="attrs" v-on="on">
                              mdi-eye mdi-24px
                            </v-icon>
                          </template>
                          <span>فعال</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-tooltip top v-if="accessDenyAddEditChief">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                              @click="enableAddEditFunction(2, item.id)" v-bind="attrs" v-on="on">
                              mdi-pencil
                            </v-icon>
                          </template>
                          <span>ویرایش</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1" color="iconColor" style="cursor: pointer" v-bind="attrs" v-on="on"
                              @click="showAttachmentModal(item?.id)">
                              mdi-attachment-plus mdi-24px
                            </v-icon>
                          </template>
                          <span>پیوست ها</span>
                        </v-tooltip>
                        <v-tooltip top v-if="accessDenyAddEditChief">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1" color="iconColor" style="cursor: pointer"
                              @click="showDeleteConfirmFunction(item?.id)" v-bind="attrs" v-on="on">
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>حذف</span>
                        </v-tooltip>
                        <v-menu rounded="lg">
                          <template v-slot:activator="{ on: menu, attrs }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on: tooltip }">
                                <v-icon class="mt-1 mx-2" color="iconColor" style="cursor: pointer" v-bind="attrs"
                                  v-on="{ ...tooltip, ...menu }">
                                  mdi-more
                                </v-icon>
                              </template>
                              <span>بیشتر</span>
                            </v-tooltip>
                          </template>
                          <v-list>
                            <v-list-item dense v-for="actionItems in actionList" :key="actionItems.id"
                              @click="actionDropdownBtn(actionItems.type, item)">
                              <v-list-item-icon>
                                <v-icon color="iconColor">{{ actionItems.icon }}</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{ actionItems.title }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>
                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" class="pa-0">
          <pagination-component ref="pagination">
            <div slot="action">
              <v-card elevation="0">
                <v-pagination class="mt-8" circle color="lightColor" v-model="page" :length="totalPages"
                  :total-visible="8" :value="totalPages" prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"
                  @next="next()" @previous="previous()" @input="input()"></v-pagination>
              </v-card>
            </div>
          </pagination-component>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <confirm-dialog ref="confirm">
          <v-row slot="action" no-gutters>
            <v-spacer></v-spacer>
            <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
              style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
              بله
            </v-btn>
            <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
              @click="confirmDialogCancelFunction()">
              خیر
            </v-btn>
          </v-row>
        </confirm-dialog>
        <v-dialog width="450" v-model="searchModal">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-magnify</v-icon>
                  <span class="modal-title-text mr-2">جستجو</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-12">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete :items="ChiefComplaintCategoryItems" no-data-text="اطلاعاتی وجود ندارد" tabindex="1"
                    dense outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                    label="دسته بندی" :autofocus="true" v-model="searchCategory" autocomplete="off"
                    prepend-inner-icon="mdi-home-city mdi-18px" style="font-size: 11px !important"></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field type="text" v-model="searchText" dense clearable clear-icon="mdi-close-circle-outline"
                    outlined v-on:keyup.enter="search()" label="عنوان" class="input-label"
                    prepend-inner-icon="mdi-text-box mdi-18px" tabindex="2"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="search()" dark rounded class="normal-letter-spacing px-12">
                جستجو
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelSearch()" class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog width="450" v-model="showAddEditModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">{{ modalIcon }}</v-icon>
                  <span class="modal-title-text mr-2">{{ modalTitle }}</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-12">
              <v-row>
                <v-col cols="12">
                  <v-text-field type="text" v-model="chiefComplaint.title" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="showConfirmDialogFunction()"
                    label="عنوان*" :autofocus="true" class="input-label" prepend-inner-icon="mdi-text-box mdi-18px"
                    tabindex="1"></v-text-field>
                </v-col>
                <v-col cols="12" class="mt-n5">
                  <v-text-field type="text" clearable clear-icon="mdi-close-circle-outline"
                    v-model="chiefComplaint.code" dense outlined v-on:keyup.enter="showConfirmDialogFunction()"
                    label="کد" class="input-label" prepend-inner-icon="mdi-text mdi-18px" tabindex="2"></v-text-field>
                </v-col>
                <v-col cols="12" class="mt-n5">
                  <v-autocomplete :items="ChiefComplaintCategoryItems" no-data-text="اطلاعاتی وجود ندارد" tabindex="3"
                    dense outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                    label="دسته بندی*" v-model="chiefComplaint.category" autocomplete="off"
                    prepend-inner-icon="mdi-home-city mdi-18px" style="font-size: 11px !important"></v-autocomplete>
                </v-col>
                <v-col cols="12" v-if="!addFlag">
                  <v-checkbox v-model="isActive" label="نمایش" hide-details tabindex="4"></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
                class="normal-letter-spacing px-12">
                ثبت
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelAddEditFunction()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog width="90%" max-width="1050px" v-model="isAttachmentModalOpen">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-attachment mdi-24px</v-icon>
                  <span class="modal-title-text mr-2">پیوست ها</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-8">
              <v-row class="mb-4">
                <v-col cols="12" class="pb-4">
                  <app-title-header title="فایل ها" />
                </v-col>
                <v-col cols="12" class="py-0">
                  <app-box outlined max-height="150px">
                    <v-chip-group column v-if="allTrainings?.length">
                      <v-chip v-for="training in allTrainings" :key="training?.id" :ripple="false" label dark close
                        :disabled="haveDublicated(training?.id)" close-icon="mdi-plus mdi-24px" class="all-chip"
                        @click:close="addNewAttachment(training)">
                        {{ training?.title }}
                      </v-chip>
                    </v-chip-group>
                    <div v-else>فایلی بارگزاری نشده است.</div>
                  </app-box>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-4">
                  <app-title-header title="فایل های انتخابی" />
                </v-col>
                <v-col cols="12" class="py-0">
                  <app-box outlined max-height="150px">
                    <v-chip-group column v-if="allAttachments?.length">
                      <v-chip v-for="{ title, id } in allAttachments" :key="id" :ripple="false" label dark close
                        close-icon="mdi-close mdi-24px" color="darkColor" @click:close="deleteAttachment(id)">
                        {{ title }}
                      </v-chip>
                    </v-chip-group>
                    <div v-else>فایلی انتخاب نشده است.</div>
                  </app-box>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2 pb-4">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="addRangeOfAttachments()" dark rounded
                class="normal-letter-spacing px-14">
                ثبت
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelAttachmentModal()"
                class="normal-letter-spacing px-12">
                انصراف
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </section>
      <section>
        <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
          :snakIcon="snakIcon"></alert-component>
      </section>
    </template>
  </app-page-container>
</template>

<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
